/**
 * Defines the different "reasons" for playback.
 */
export var Reason;
(function (Reason) {
    /**
     * The program started and the song autostarted
     */
    Reason["APPLOAD"] = "appload";
    /**
     * The back button was pressed.
     */
    Reason["BACK_BUTTON"] = "backbtn";
    /**
     * A row in the song list was clicked/opened.
     */
    Reason["CLICK_ROW"] = "clickrow";
    /**
     * The song was started from a click on the sidebar.
     */
    Reason["CLICK_SIDE"] = "clickside";
    /**
     * The song was ended (will never cause a song to start).
     */
    Reason["END_PLAY"] = "endplay";
    /**
     * The forward button was pressed.
     */
    Reason["FORWARD_BUTTON"] = "fwdbtn";
    /**
     * The user logged out (will never cause a song to start).
     */
    Reason["LOGOUT"] = "logout";
    /**
     * The play button was pressed.
     */
    Reason["PLAY_BUTTON"] = "playbtn";
    /**
     * Play was chosen from a popup menu.
     */
    Reason["POPUP"] = "popup";
    /**
     * A remote control request.
     */
    Reason["REMOTE"] = "remote";
    /**
     * A track ended because it had been played in full.
     */
    Reason["TRACK_DONE"] = "trackdone";
    /**
     * A track ended because of errors in the track.
     */
    Reason["TRACK_ERROR"] = "trackerror";
    /**
     * Client doesn't know.
     */
    Reason["UNKNOWN"] = "unknown";
    /**
     * A URL was opened.
     */
    Reason["URI_OPEN"] = "uriopen";
    /**
     * Playback was capped
     */
    Reason["CAPPED"] = "capped";
})(Reason || (Reason = {}));
//# sourceMappingURL=reason.js.map